import React, { useEffect, useState } from "react";
import { FaCircleInfo } from "react-icons/fa6";

export default function Notification({ message, onClose }) {
  const [isVisible, setIsVisible] = useState(true);

  // Auto-close after 5 seconds with fade-out
  useEffect(() => {
    if (!message) return;

    const fadeTimer = setTimeout(() => {
      setIsVisible(false);
    }, 4500); // Start fade-out at 4.5 seconds

    const closeTimer = setTimeout(() => {
      onClose();
    }, 5000); // Close at 5 seconds

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(closeTimer);
    };
  }, [message, onClose]);

  if (!message) return null;
  return (
    <div
      className="fixed bottom-8 left-1/2 z-[99999] flex w-1/5 items-center justify-center gap-2 rounded-xl border-2 border-primary bg-ewave-darker p-4 text-center text-base text-white"
      style={{
        animation: isVisible ? "fadein 0.3s" : "fadeout 0.5s",
        opacity: isVisible ? 1 : 0,
      }}
    >
      <FaCircleInfo className="text-2xl text-white" />
      {message}
      <style>{`
        @keyframes fadein { from { opacity: 0; bottom: 0; } to { opacity: 1; bottom: 32px; } }
        @keyframes fadeout { from { opacity: 1; } to { opacity: 0; } }
      `}</style>
    </div>
  );
}
